import { computed, toValue } from 'vue';
import { useStore } from 'vuex';

// people who tracked a task (and its executor), most tracked first, with their approved manual time;
// the task tracked right now takes its tracked users from the store, so its time keeps ticking
export function useTaskSpentTimes(task) {
  const store = useStore();
  const activeTrackingTask = computed(() => store.state.task.activeTrackingTask);

  return computed(() => {
    const { id, taskTrackedByUsers, manualTime, executorId } = toValue(task);
    const ttbus = activeTrackingTask.value?.id === id
      ? activeTrackingTask.value.taskTrackedByUsers
      : taskTrackedByUsers;
    if (!ttbus) {
      return [];
    }
    return ttbus.reduce((acc, ttbu) => {
      const manualTimeTotalSeconds = (manualTime || []).reduce(
        (sum, mt) => (mt.userId === ttbu.userId && mt.status === 'approved' ? sum + mt.duration : sum),
        0,
      );
      if (
        ttbu.totalSeconds
        || (ttbu.timeSlots?.length && ttbu.timeSlots[0].trackStarted)
        || ttbu.userId === executorId
      ) {
        acc.push({
          id: ttbu.id,
          ttbuObj: ttbu,
          userId: ttbu.userId,
          manualTimeTotalSeconds,
          manualTimePercent: Math.floor((manualTimeTotalSeconds / ttbu.totalSeconds) * 100),
          allTime: ttbu.totalSeconds + ((ttbu.timeSlots?.length && ttbu.timeSlots[0].actualTimeSeconds) || 0),
        });
      }
      return acc;
    }, []).sort((a, b) => b.allTime - a.allTime);
  });
}
